<template>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
      </div>
    </div>
  
    <div class="container-fluid py-3 mt-2">
      <!-- 🔹 제목 -->
      <div>
        <p class="custom-text-h4 font-weight-bold text-black ma-2">Scan History</p>
        <p class="font-weight-bold ml-5 mt-0 text-gray">
          <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Material Management > Scan History
        </p>
      </div>
      <v-row class="d-flex align-items-center mb-1">
  
        
        <v-col cols="3" class="d-flex align-items-center" >
            <div class="label-box date-label-box">Date</div>

            <!-- date picker 2개 나란히 -->
            <div class="d-flex align-center mt-2" style="gap: 0px;" >

            <!-- 시작 날짜 Datepicker -->
            <vue-datepicker 
                v-model="date1"
                :class="'custom-datepicker' " 
                class="bg-white custom-datepicker mb-2 startDate"
                name="startDate"
                placeholder="Start Date"
                :text-input="textInputOptions"
                :is-24="false"
                :enable-time-picker="false"
                arrow-navigation
                format="yyyy-MM-dd"
                :max="date2"
                :auto-apply="true" 

            />

            <!-- 하이픈(-) -->
            <span class="mx-3 mb-1">~</span>

            <!-- 종료 날짜 Datepicker -->
            <vue-datepicker 
                v-model="date2"
                :class="'custom-datepicker'" 
                class="bg-white custom-datepicker mb-2"
                style="padding-right: 0px;"
                placeholder="End Date"
                :text-input="textInputOptions"
                :is-24="false"
                :enable-time-picker="false"
                arrow-navigation
                format="yyyy-MM-dd"
                :min="date1"
                :auto-apply="true" 

            />
            </div>
        </v-col>

        
        <!-- 검색 버튼 -->
        <v-col cols="auto" class="d-flex justify-end">
            <v-btn color="primary" class="search-btn ml-5" @click="getfilterData">
            <v-icon left>mdi-magnify</v-icon> Search
            </v-btn>
        </v-col>
        

        </v-row>
        <v-row>
        <!-- 왼쪽: Scan History Data -->
        <v-col cols="6" style="padding-top: 0;">
            <v-card class="custom-card" elevation="2">
            <v-card-title class="custom-card-title">Scan History Data</v-card-title>
            <div class="additional-content mt-3" style="padding-top: 3px;">
                <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="-1"
                v-model:items-per-page="itemsPerPage"
                class="elevation-1 detail-table2 lift-up"
                height="72vh"
                density="compact"
                hover
                fixed-header
                >
                <template v-slot:bottom></template>
                <template #item="{ item }">
                    <tr @click="openDetailPanel($event, { item })" style="cursor: pointer;">
                    <td>{{ item.companyName }}</td>
                    <td>{{ item.scanDate }}</td>
                    <td style="text-align: right;">{{ formatNumber(item.totalQty) }}</td>
                    <td style="text-align: right;">{{ formatNumber(item.itemCount) }}</td>
                    </tr>
                </template>
                </v-data-table>
            </div>
            </v-card>
        </v-col>

        <!-- 오른쪽: Scan History Detail -->
        <v-col cols="6" style="padding-top: 0;">
            <v-card class="custom-card" elevation="2">
            <v-card-title class="custom-card-title">Scan History Detail</v-card-title>
            <div class="additional-content mt-3" style="padding-top: 3px;">
                <v-data-table
                :headers="detailHeaders"
                :items="detailItems"
                :items-per-page="-1"
                class="elevation-1 detail-table2 lift-up"
                height="72vh"
                density="compact"
                hover
                fixed-header
                >

                <template v-slot:bottom></template>
                <template v-slot:item="props">
                    <tr>
                    <td>{{ props.item.partNumber }}</td>
                    <td>{{ props.item.scanDates }}</td>
                    <td style="text-align: right;">{{ formatNumber(props.item.quantity) }}</td>
                    <td>{{ props.item.lotDate }}</td>
                    </tr>
                </template>
                </v-data-table>
            </div>
            </v-card>
        </v-col>
        </v-row>

    </div>
  </template>
  
  <script>
  import axios from "axios";
  import "@vuepic/vue-datepicker/dist/main.css";
  import VueDatepicker from "@vuepic/vue-datepicker";
  import { mapState } from "vuex";

  export default {
    components: {
            VueDatepicker,
            
        },
    data() {

      return {
        date1: this.getFirstDayOfMonth(), // 이번 달 1일
        date2: this.getToday(), // 오늘 날짜
        loading: false,
        search: {
          scanData: '',
        },
        textInputOptions: {
          openMenu: true,
          enterSubmit: true,
        },
        items: [],
        detailItems: [],
        headers: [
            { title: "Company Name", key: "companyName", align: "center", sortable: false },
            { title: "Scan Date", key: "scanDate", align: "center", sortable: false },
            { title: "Total Quantity", key: "totalQty", align: "center", sortable: false },
            { title: "Item Count", key: "itemCount", align: "center", sortable: false },
        ],
        detailHeaders: [
            { title: "Part Number", key: "partNumber", align: "center", sortable: false },
            { title: "Scan Date", key: "scanDates", align: "center", sortable: false },
            { title: "Quantity", key: "quantity", align: "center", sortable: false },
            { title: "Lot Date", key: "lotDate", align: "center", sortable: false },
        ],

      };
    },
    async mounted() {
        const hasAccess = await this.checkMaterialManagementAccess();

        if (!hasAccess) {
            this.$router.push('/materialMain'); // ❗허용되지 않은 회사면 리다이렉트
            return;
        }
      this.$nextTick(() => {
        this.$refs.barcodeInput?.focus();
      });
      this.getfilterData();
    },
    computed: {
        // filteredItems() {
        //     return this.items.filter(item => 
        //         item.poNumber.toLowerCase().includes(this.search.toLowerCase())
        //     );
        // },
        normalizedUsername() {
          return String(this.username || "").trim().toUpperCase();
        },
        ...mapState({
        username: (state) => state.username, // Vuex 상태에서 username 가져오기
        userName: (state) => state.userName
        }),
    },
    methods: {
        async checkMaterialManagementAccess() {
            if (!this.normalizedUsername) return false;

            try {
                const response = await axios.get("/api/getCompanyFeatureVisibility");
                const materialScanVisible = response.data?.data?.materialScanVisible || [];

                return materialScanVisible
                    .map(code => String(code || "").trim().toUpperCase())
                    .includes(this.normalizedUsername);
            } catch (error) {
                console.error("getCompanyFeatureVisibility API error:", error);
                return false;
            }
        },
        getFirstDayOfMonth() {
            const now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), 1); // 이번 달 1일
        },
        getToday() {
            return new Date(); // 오늘 날짜
        },
        formatItemNumber(rawItemNo) {
            const cleaned = rawItemNo.replace(/-/g, "");
            if (!isNaN(parseFloat(cleaned.charAt(0))) && isFinite(cleaned.charAt(0))) {
                return cleaned.substring(0, 5) + "-" + cleaned.substring(5);
            } else {
                return cleaned.substring(0, 6) + "-" + cleaned.substring(6);
            }
        },
      formatNumber(value) {
        if (!value) return "0";
        return Number(value).toLocaleString();
      },
      formatDateToYYYYMMDD(date) {
            if (!date) return ""; // 날짜가 없을 경우 빈 값 반환
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, "0"); // 두 자리 숫자로 변환
            const day = String(d.getDate()).padStart(2, "0"); // 두 자리 숫자로 변환
            return `${year}${month}${day}`; // YYYYMMDD 형식으로 반환
        },
    formatDate(dateString) {
        if (!dateString) return "";
        const strDate = dateString.toString();
        return `${strDate.substring(0, 4)}-${strDate.substring(4, 6)}-${strDate.substring(6, 8)}`;
    },
      async getfilterData() {
            this.loading = true;
            this.detailItems = [];
            try {
                const response = await axios.get("/api/scanHistoryList", {
                params: {
                    username: this.username,
                    startDate: this.formatDateToYYYYMMDD(this.date1),
                    endDate: this.formatDateToYYYYMMDD(this.date2),
                }
                });

                if (response.data.success) {
                const data = response.data.items;
                if (data.length === 0) {
                    this.items = [];
                    return;
                }
                //console.log(data)
                this.items = data.map((item) => ({
                        detailInfo : item.REF02.trim(),
                        companyName: item.CST_NM,
                        scanDate: this.formatDate(item.FirstDate), // 포맷 필요시
                        totalQty: item.TotalQuantity || 0,
                        itemCount: item.UniqueItemCount || 0,
                    }));
                } else {
                console.error("❌ 바코드 조회 실패:");
                this.items = [];
                }
            } catch (error) {
                console.error("❌ 바코드 조회 실패:", error);
                this.items = [];
            } finally {
                this.loading = false;
            }
        },

        openDetailPanel(event, { item }) {
            this.loading=true;
            const detailInfo = item.detailInfo;
            const username = this.username;
            if (!detailInfo || !username) return;
            //console.log(detailInfo,username)
            axios.get("/api/getScanHistoryDetail", {
                params: {
                    detailInfo,
                    username,
                }
            }).then((response) => {
                //console.log(response.data)
                if (response.data.success) {
                    this.detailItems = response.data.items.map((row) => ({
                        partNumber: row.ITMNO.trim(),
                        scanDates: this.formatDate(row.TRSDT).trim(),
                        quantity: row.QUNTY,
                        lotDate: row.LOTNO,
                    }));
                } else {
                this.detailItems = [];
                }
                //console.log(this.detailItems)
                this.loading=false;

            }).catch((err) => {
                console.error("❌ 상세 데이터 조회 실패:", err);
                this.loading=false;
                this.detailItems = [];
            });
            },

      onBarcodeScanned() {
        if (this.search.partNumber && this.search.partNumber.length > 0) {
          this.getfilterData();
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .container-fluid {
    height: 92%;
    overflow-y: auto;
  }
  .custom-text-h4 {
    font-size: 3rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    text-transform: none !important;
  }
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  }
  .loading-container {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(0, 123, 255, 0.3);
    border-top: 5px solid #007bff;
    border-radius: 50%;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .loading-text {
    font-size: 64px;
    font-weight: bold;
    text-transform: uppercase;
    background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    color: transparent;
    animation: waveColor 3s ease-in-out infinite;
  }
  @keyframes waveColor {
    0% { background-position: 0% 70%; }
    50% { background-position: 100% 30%; }
    100% { background-position: 0% 70%; }
  }
  .split-box1 {
    display: flex;
    width: 90vh;
    height: 45px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    overflow: hidden;
    font-size: 16px;
  }
  .label-box {
    background-color: #f4f4f4;
    padding: 0 16px;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #374151;
    white-space: nowrap;
    border-right: 1px solid #d1d5db;
  }
  .select-box {
    flex: 1;
    padding-left: 16px;
    display: flex;
    align-items: center;
    color: #374151;
    font-weight: bold;
    background-color: white;
  }
  .custom-card {
    width: 100%;
    height: 80vh;
  }
  .custom-card-title {
    background-color: #6ea6d9;
    color: white;
    font-weight: bold;
    font-size: 18px;
    padding: 6px 20px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    text-align: left;
    position: relative;
    z-index: 50 !important;
  }
  .additional-content {
    padding: 20px;
    font-size: 16px;
    color: #333;
  }
  :deep(.v-data-table thead th) {
    background-color: #e3f2fd !important;
    font-weight: bold !important;
    text-align: center;
  }
  :deep(.v-data-table tbody td) {
    font-size: 15px !important;
    font-weight: 500;
    text-align: center;
  }
  :deep(.v-data-table tbody td:nth-child(6)) {
    text-align: right !important;
  }

  :deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
:deep() .v-table .v-table__wrapper > table > tbody > tr > td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep(.v-data-table thead th:nth-child(1)) {
  width: 30vh !important;
}

@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}
/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'hyundai' !important;
}


.startDate {
  margin-left: 0px !important; /* ✅ 강제 제거 */
}

.label-box {
  background-color: #f4f4f4; /* 🔵 라벨 배경색 */
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
}
:deep(.dp__input) {
    width: 150px !important;
    height: 45px !important;
    border-radius: 5px !important;
    padding: 5px 2px !important;
    text-align: center !important;
    font-size: 14px !important;
    border-top-left-radius: 0% !important;
        border-bottom-left-radius: 0% !important;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important;
}
.date-label-box {
  background-color: #f4f4f4;
  height: 45px; /* ✅ 여기에 맞춤 */
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border: 1px solid #d1d5db;
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.custom-datepicker {
  width: 150px;
  height: 45px; /* ✅ 이걸 45px로! */
  border-radius: 0 4px 4px 0;
  text-align: center;
  font-size: 14px;
}


/* ✅ Datepicker 드롭다운 크기 조절 */
:deep(.dp__menu_inner) {
    width: 260px !important; /* ✅ 너비 조정 */
    font-size: 14px !important; /* ✅ 폰트 크기 조정 */
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5 !important; /* 짝수 행 연한 회색 */
}

:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: white !important; /* 홀수 행 흰색 */
}


  </style>
  
